module.exports = "https://static.wanderu.com/static/media/ferry-grey.9190f992.svg";